import { Box, Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Visibility } from "@material-ui/icons";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import React from "react";
import { useDispatch } from "react-redux";
import _ from "underscore";
import { getTransactionUrl, IsNullOrEmpty } from "../../helpers/utility";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(1),
  },
  icon: {
    [theme.breakpoints.down("md")]: {
      position: "relative",
      top: -10,
    },
  },
  chip: {
    marginRight: theme.spacing(1),
    background: theme.palette.info.main,
    color: "white",
  },
}));

export default function WithdrawList(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const actionRenderer = () => {
    return {
      name: "id",
      label: "Info",
      options: {
        filter: false,
        customBodyRender: (value) => {
          let user = props.withdraws.filter((item) => {
            return item.id === value;
          });
          return (
            <Visibility
              className={classes.icon}
              color="secondary"
              onClick={() => props.onDetailsOpen(user[0])}
            />
          );
        },
      },
    };
  };

  const hashRenderer = () => {
    return {
      name: "id",
      label: "Transaction Hash",
      options: {
        setCellProps: () => ({
          align: "center",
        }),
        filter: false,
        sort: true,
        customBodyRender: (value) => {
          let item = _.find(props.withdraws, (s) => s.id === value);
          return item.transactionhash ? (
            <a
              target="_blank"
              href={getTransactionUrl(item.type) + item.transactionhash}
            >
              Click
            </a>
          ) : (
            <></>
          );
        },
      },
    };
  };

  const chargeRenderer = () => {
    return {
      name: "id",
      label: "Charge Hash",
      options: {
        setCellProps: () => ({
          align: "center",
        }),
        filter: false,
        sort: true,
        customBodyRender: (value) => {
          let item = _.find(props.withdraws, (s) => s.id === value);
          return item.parentTransactionHash ? (
            <a
              target="_blank"
              href={getTransactionUrl(item.type) + item.parentTransactionHash}
            >
              Click
            </a>
          ) : (
            <></>
          );
        },
      },
    };
  };

  const statusRenderer = () => {
    return {
      name: "status",
      label: "Status",
      options: {
        setCellProps: () => ({
          align: "center",
        }),
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return (
            <Chip
              label={value}
              style={{
                background:
                  value === "Completed"
                    ? "green"
                    : value === "Admin Pending"
                    ? "goldenrod"
                    : value === "Rejected"
                    ? "red"
                    : value === "Admin Processing"
                    ? "#6E260E"
                    : "teal",
              }}
            />
          );
        },
      },
    };
  };

  const columns = [
    {
      name: "createdTime",
      label: "Created Date",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "updatedTime",
      label: "Updated Time",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "coins",
      label: "Transfered Coins",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          align: "right",
        }),
      },
    },
    {
      name: "transactionCharge",
      label: "Transaction Charge",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          align: "right",
        }),
      },
    },
    hashRenderer(),
    chargeRenderer(),
    statusRenderer(),
    actionRenderer(),
  ];

  const tenants = {};

  props.users &&
    props.users.forEach((x) => {
      tenants[x.id] = x.tenantName;
    });

  const data = _.sortBy(props.withdraws, (t) => t.createdOn.seconds)
    .reverse()
    .map((item) => {
      return {
        id: item.id,
        createdTime: moment
          .unix(item.createdOn.seconds)
          .format("DD-MM-YYYY hh:mm:ss A"),
        updatedTime: moment
          .unix(item.updatedOn.seconds)
          .format("DD-MM-YYYY hh:mm:ss A"),
        transactionCharge: item.transactionChargeFees + " " + item.type,
        coins:
          item.coins + " " + (item.tokenSymbol ? item.tokenSymbol : item.type),
        status:
          item.transactionhash &&
          item.parentTransactionHash &&
          item.parentTransactionHash !== "Admin Processing"
            ? "Completed"
            : item.parentTransactionHash === "Admin Processing"
            ? "Admin Processing"
            : item.transactionhash && !item.parentTransactionHash
            ? "Admin Pending"
            : item.status,
        fromAddress: item.fromAddress,
        email: tenants[item.tenantId],
        hash: item.transactionhash,
        name: item.cid,
        chargehash: item.parentTransactionHash,
      };
    });

  // const handleWithdraw = async () => {
  //   let x = await Promise.all(
  //     props.withdraws
  //       .filter((t) => t.transactionhash && !t.parentTransactionHash)
  //       .slice(0, 3)
  //       .map(async (s) => {
  //         return await SettingAPI.SendAdminTransaction("withdraw", s.id).then(
  //           (l) => {
  //             dispatch(
  //               updateWithdrawSuccess({
  //                 dat: l,
  //                 id: l.id,
  //               })
  //             );
  //           }
  //         );
  //       })
  //   );
  //   console.log(x);
  // };

  const totalCoins =
    props.withdraws &&
    props.withdraws
      .filter((t) => !IsNullOrEmpty(t.transactionhash))
      .reduce((s, f) => {
        return s + parseFloat(f.coins); // return the sum of the accumulator and the current time, as the the new accumulator
      }, 0);

  const total =
    props.withdraws &&
    props.withdraws
      .filter((t) => !IsNullOrEmpty(t.transactionhash))
      .reduce((s, f) => {
        return s + parseFloat(f.transactionChargeFees); // return the sum of the accumulator and the current time, as the the new accumulator
      }, 0);

  const settled =
    props.withdraws &&
    props.withdraws
      .filter((t) => !IsNullOrEmpty(t.parentTransactionHash))
      .reduce((s, f) => {
        return s + parseFloat(f.transactionChargeFees); // return the sum of the accumulator and the current time, as the the new accumulator
      }, 0);

  const transCharge =
    props.withdraws &&
    props.withdraws
      .filter((t) => !IsNullOrEmpty(t.parentTransactionHash))
      .reduce((s, f) => {
        return s + parseFloat(f.transactionCharge); // return the sum of the accumulator and the current time, as the the new accumulator
      }, 0);

  const pending =
    props.withdraws &&
    props.withdraws
      .filter(
        (t) =>
          !IsNullOrEmpty(t.transactionhash) &&
          IsNullOrEmpty(t.parentTransactionHash)
      )
      .reduce((s, f) => {
        return s + parseFloat(f.transactionChargeFees); // return the sum of the accumulator and the current time, as the the new accumulator
      }, 0);

  return (
    <div className={classes.container}>
      <Box display={"flex"} justifyContent={"space-between"}>
        <table className="table table-striped">
          <tr>
            <th>Total Coins</th>
            <td>{totalCoins && totalCoins.toFixed(8)}</td>
            <th>Transaction Charge</th>
            <td>{transCharge && transCharge.toFixed(3)}</td>
          </tr>
          <tr>
            <th>Total Fees</th>
            <td>{total && total.toFixed(8)}</td>
            <th>Total Transactions</th>
            <td>
              {props.withdraws &&
                props.withdraws.filter(
                  (t) => !IsNullOrEmpty(t.parentTransactionHash)
                ).length}
            </td>
          </tr>
          <tr>
            <th>Fees Collected</th>
            <td>{settled && settled.toFixed(8)}</td>
            <th>Fees Transactions</th>
            <td>
              {props.withdraws &&
                props.withdraws.filter(
                  (t) => !IsNullOrEmpty(t.parentTransactionHash)
                ).length}
            </td>
          </tr>
          <tr>
            <th>Fees Pending</th>
            <td>{pending && pending.toFixed(8)}</td>
            <th>Pending Transactions</th>
            <td>
              {props.withdraws &&
                props.withdraws.filter(
                  (t) =>
                    !IsNullOrEmpty(t.transactionhash) &&
                    IsNullOrEmpty(t.parentTransactionHash)
                ).length}
            </td>
          </tr>
        </table>
      </Box>
      <MUIDataTable
        title={"Withdraw`s List"}
        data={data}
        columns={columns}
        options={{
          filterType: "checkbox",
          selectableRows: "none",
          rowsPerPageOptions: [10],
        }}
      />
      {/* <Button
        
        variant="contained"
        color="primary"
        onClick={() => handleWithdraw()}
      >
        Send Admin Coins
      </Button>
      <Button
        
        variant="contained"
        color="secondary"
        onClick={() => handleRestart()}
      >
        Restart Withdraw
      </Button> */}
    </div>
  );
}
